import axios from 'src/utils/httpClients/axios';

import { HOST_API } from 'src/config';
import { WorkflowDashboardRunDto } from 'src/@types/workflow/types';

const baseUrl = `${HOST_API}users/me/workflow-instances`;

export async function getWorkflowRunsForOwnDocuments(
  limit: number,
  signal?: AbortSignal
): Promise<WorkflowDashboardRunDto[]> {
  const response = await axios.get<WorkflowDashboardRunDto[]>(baseUrl, {
    params: { limit },
    signal,
  });

  return response.data ?? [];
}
